import { configService } from '@/services'

/** Storefront origin for previews and cache purges: VITE_STOREFRONT_ORIGIN, else the store's own domain. */
export const storefrontOrigin = (domain?: string) =>
  import.meta.env.VITE_STOREFRONT_ORIGIN || import.meta.env.VITE_STOREFRONT_URL || (domain ? `https://${domain}` : '')

/** Headers the storefront forwards to the backend to confirm this admin user (same as the admin's API client). */
export const adminHeaders = (): Record<string, string> => {
  const apiConfig = configService.getConfig()?.apiConfig
  const token = localStorage.getItem('access_token') || apiConfig?.bearerToken
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(apiConfig?.clientHost ? { 'X-Client-Host': apiConfig.clientHost } : {}),
    ...(apiConfig?.systemUid ? { 'X-System-Uid': apiConfig.systemUid } : {}),
  }
}

/** Mints a 30-minute preview token: for the theme (`{ scope: 'theme' }`) or one campaign (`{ offerId }`). */
export const mintPreviewToken = async (origin: string, body: { scope: 'theme' } | { offerId: string }) => {
  const res = await fetch(`${origin}/api/preview-token`, { method: 'POST', headers: adminHeaders(), body: JSON.stringify(body) })
  const json = (await res.json().catch(() => ({}))) as { token?: string }
  if (!res.ok || !json.token) throw new Error('Preview token refused')
  return json.token
}

/** Purges the store's cached config, offers and campaigns so a save shows on the storefront at once. */
export const revalidateStore = async (origin: string) => {
  const res = await fetch(`${origin}/api/_revalidate`, { method: 'POST', headers: adminHeaders() })
  if (!res.ok) throw new Error('Revalidate failed')
}
